var map = {
	"./Green-east.png": 28187,
	"./Green-north-east.png": 91391,
	"./Green-north-west.png": 66101,
	"./Green-north.png": 89807,
	"./Green-south-east.png": 46079,
	"./Green-south-west.png": 56586,
	"./Green-south.png": 21480,
	"./Green-west.png": 83248,
	"./Orange-east.png": 21859,
	"./Orange-north-east.png": 85119,
	"./Orange-north-west.png": 94468,
	"./Orange-north.png": 35300,
	"./Orange-south-east.png": 73566,
	"./Orange-south-west.png": 29930,
	"./Orange-south.png": 53131,
	"./Orange-west.png": 16711,
	"./Red-east.png": 60942,
	"./Red-north-east.png": 24676,
	"./Red-north-west.png": 77118,
	"./Red-north.png": 68016,
	"./Red-south-east.png": 27744,
	"./Red-south-west.png": 27320,
	"./Red-south.png": 63357,
	"./Red-west.png": 43336,
	"./Thumbs.db": 20832,
	"./Yellow-east.png": 23227,
	"./Yellow-north-east.png": 82410,
	"./Yellow-north-west.png": 35626,
	"./Yellow-north.png": 37776,
	"./Yellow-south-east.png": 18826,
	"./Yellow-south-west.png": 8384,
	"./Yellow-south.png": 20601,
	"./Yellow-west.png": 65206,
	"./gray-east.png": 82891,
	"./gray-north-east.png": 36030,
	"./gray-north-west.png": 34984,
	"./gray-north.png": 55236,
	"./gray-south-east.png": 70821,
	"./gray-south-west.png": 97318,
	"./gray-south.png": 37980,
	"./gray-west.png": 20263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68681;